/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IOperationMetadata, IOperationMetadataJSON } from '../descriptors/operationmetadatadescriptor';

export default class OperationMetadataHelpers {
	/**
	 * Prepares metadata data for all operations. Adds metadata to operations with type 0.
	 */
	public static prepareMetadataForOperations( types: number[], metadata: IOperationMetadataJSON[] ): IOperationMetadataJSON[] {
		if ( !types?.length || !metadata?.length ) {
			return [];
		}

		const result: IOperationMetadataJSON[] = [];

		let index: number = 0;

		for ( const type of types ) {
			if ( type === 0 ) {
				result.push( result[ result.length - 1 ] );

				continue;
			}

			if ( !metadata[ index ] ) {
				throw new Error( 'Missing metadata for a operation' );
			}

			result.push( metadata[ index ] );

			index++;
		}

		return result;
	}

	/**
	 * Removes unnecessary metadata for operations with type 0.
	 */
	public static removeUnnecessaryMetadata( types: number[], metadata: IOperationMetadata[] ): IOperationMetadata[] {
		if ( !types?.length || !metadata?.length ) {
			return [];
		}

		const result: IOperationMetadata[] = [];

		for ( let i: number = 0; i < types.length; i++ ) {
			if ( types[ i ] === 0 ) {
				continue;
			}

			if ( !metadata[ i ] ) {
				throw new Error( 'Missing metadata for a operation' );
			}

			result.push( metadata[ i ] );
		}

		return result;
	}
}
